import { Chip, LinearProgress, linearProgressClasses, styled } from '@mui/material';
import { lowerCase, startCase } from 'lodash';
import { EmptyText } from 'src/utils/constants/config';

export const StyledLinearProgressCreditUsage = styled(LinearProgress)(({ theme }) => ({
  height: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: theme.shape.borderRadius * 2,
  },
  background: theme.palette.background.paper2,
}));

export const getActivityChip = (activity?: string) => {
  switch (lowerCase(activity)) {
    case 'view':
      return <Chip color="success" label={startCase(activity)} size="small" />;
    case 'export':
      return <Chip color="secondary" label={startCase(activity)} size="small" />;
    case 'print':
      return <Chip color="warning" label={startCase(activity)} size="small" />;
    default:
      return EmptyText;
  }
};
